export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const FECTH_USERS_SUCCESS = 'FECTH_USERS_SUCCESS';
export const FECTH_USERS_FAIL = 'FECTH_USERS_FAIL';
export const FECTH_USER_SUCCESS = 'FECTH_USER_SUCCESS';
export const FECTH_USER_FAIL = 'FECTH_USER_FAIL';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';


export const FECTH_FOODS_SUCCESS = 'FECTH_FOODS_SUCCESS';
export const FECTH_FOODS_FAIL = 'FECTH_FOODS_FAIL';
export const FECTH_FOOD_SUCCESS = 'FECTH_FOOD_SUCCESS';
export const FECTH_FOOD_FAIL = 'FECTH_FOOD_FAIL';
export const CREATE_FOOD_SUCCESS = 'CREATE_FOOD_SUCCESS';
export const CREATE_FOOD_FAIL = 'CREATE_FOOD_FAIL';
export const UPDATE_FOOD_SUCCESS = 'UPDATE_FOOD_SUCCESS';
export const UPDATE_FOOD_FAIL = 'UPDATE_FOOD_FAIL';
export const DELETE_FOOD_SUCCESS = 'DELETE_FOOD_SUCCESS';
export const DELETE_FOOD_FAIL = 'DELETE_FOOD_FAIL';


export const FECTH_DIAGNOSES_SUCCESS = 'FECTH_DIAGNOSES_SUCCESS';
export const FECTH_DIAGNOSES_FAIL = 'FECTH_DIAGNOSES_FAIL';
export const FECTH_DIAGNOSIS_SUCCESS = 'FECTH_DIAGNOSIS_SUCCESS';
export const FECTH_DIAGNOSIS_FAIL = 'FECTH_DIAGNOSIS_FAIL';
export const CREATE_DIAGNOSIS_SUCCESS = 'CREATE_DIAGNOSIS_SUCCESS';
export const CREATE_DIAGNOSIS_FAIL = 'CREATE_DIAGNOSIS_FAIL';
export const UPDATE_DIAGNOSIS_SUCCESS = 'UPDATE_DIAGNOSIS_SUCCESS';
export const UPDATE_DIAGNOSIS_FAIL = 'UPDATE_DIAGNOSIS_FAIL';
export const DELETE_DIAGNOSIS_SUCCESS = 'DELETE_DIAGNOSIS_SUCCESS';
export const DELETE_DIAGNOSIS_FAIL = 'DELETE_DIAGNOSIS_FAIL';
